<template>
  <div>
    <div class="p-3 card mb-3">
      <label class="titlePage">Apresentação</label>
      <template v-if="items.length === 0">
        <table class="table table-bordered table-condensed table-striped table-hover relatorio">
          <tr>
            <th scope="col" class=""></th>
            <th scope="col" class="">Horário de abertura</th>
            <th scope="col" class=""></th>
            <th scope="col" class="">Horário de fechamento</th>
            <th scope="col" class="">Tempo de Prova</th>
            <th scope="col" class="">Tempo de Permanência</th>
          </tr>
          <tr>
            <td>
              <div class="d-flex">
                <input type="checkbox" v-model="flagAbertura" class="mx-auto align-middle" />
              </div>
            </td>
            <td>
              <fccInput required v-model="horarioAbertura"> </fccInput>
            </td>
            <td>
              <div class="d-flex">
                <input type="checkbox" v-model="flagFechamento" class="mx-auto align-middle" />
              </div>
            </td>
            <td>
              <fccInput required v-model="horarioFechamento"> </fccInput>
            </td>
            <td class="col-2">
              <div class="d-flex">
                <input type="checkbox" v-model="flagTempoProva" class="mx-auto align-middle" />
              </div>
            </td>
            <td class="col-2">
              <div class="d-flex">
                <input
                  type="checkbox"
                  v-model="flagTempoPermanencia"
                  class="mx-auto align-middle"
                />
              </div>
            </td>
          </tr>
        </table>

        <div class="text-right mb-3">
          <fccButton @click="adicionar" :disabled="!todosCamposSelecionados">{{
            labelsSystem.salvar
          }}</fccButton>
        </div>
      </template>

      <template v-else>
        <fccTable striped hover responsive :fields="fields" :items="items"> </fccTable>
        <div class="text-right mb-3">
          <fccButton @click="excluir" :disabled="abaDesabilitada">{{
            labelsSystem.excluir
          }}</fccButton>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import fccStore from '../../../../../store'

export default {
  props: ['abaDesabilitada'],
  data() {
    return {
      items: [],
      flagAbertura: false,
      horarioAbertura: 'Horário de abertura dos portões',
      flagFechamento: false,
      horarioFechamento: 'Horário de fechamento dos portões',
      flagTempoProva: false,
      flagTempoPermanencia: false,
      fields: [
        { key: 'flagabertura', label: 'Apresentar Horário de Abertura', sortable: true },
        { key: 'horarioabertura', label: 'Horário de Abertura', sortable: true },
        { key: 'flagfechamento', label: 'Apresentar Horário de Fechamento', sortable: true },
        { key: 'horariofechamento', label: 'Horário de Fechamento', sortable: true },
        { key: 'flagtempoprova', label: 'Apresentar Tempo de Prova', sortable: true },
        { key: 'flagtempopermanencia', label: 'Apresentar Tempo de Permanência', sortable: true }
      ]
    }
  },
  computed: {
    configuracao() {
      return fccStore.state.localDeProva.configuracao
    },
    todosCamposSelecionados() {
      return true
    },
    payload() {
      return {
        idApresentacao: 0,
        idLocalConfig: this.configuracao.idlocalconfig,
        flagAbertura: this.flagAbertura,
        horarioAbertura: this.horarioAbertura,
        flagFechamento: this.flagFechamento,
        horarioFechamento: this.horarioFechamento,
        dtConfig: this.configuracao.dataconfig,
        flagTempoProva: this.flagTempoProva,
        flagTempoPermanencia: this.flagTempoPermanencia
      }
    }
  },
  created() {
    this.listarApresentacao()
  },
  methods: {
    reset() {
      this.flagAbertura = false
      this.horarioAbertura = 'Horário de abertura dos portões'
      this.flagFechamento = false
      this.horarioFechamento = 'Horário de fechamento dos portões'
      this.flagTempoProva = false
      this.flagTempoPermanencia = false
    },
    adicionar() {
      axios
        .post(
          fccStore.state.baseUrlLocalDeProva + 'LocalExameApresentacao/Inserir',
          this.payload,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarApresentacao()
        })
        .catch(this.setErrorSystem)
    },
    listarApresentacao() {
      axios
        .get(
          fccStore.state.baseUrlLocalDeProva +
            `LocalExameApresentacao/GetByGetByLocalApresentacao/${this.configuracao.idlocalconfig}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.items = response.data.map((item) => {
            const newItem = { ...item }
            newItem.flagabertura = newItem.flagabertura ? 'SIM' : 'NÃO'
            newItem.flagfechamento = newItem.flagfechamento ? 'SIM' : 'NÃO'
            newItem.flagtempoprova = newItem.flagtempoprova ? 'SIM' : 'NÃO'
            newItem.flagtempopermanencia = newItem.flagtempopermanencia ? 'SIM' : 'NÃO'
            return newItem
          })
        })
        .catch(this.setErrorSystem)
    },
    excluir() {
      axios
        .delete(
          fccStore.state.baseUrlLocalDeProva +
            `LocalExameApresentacao/Delete/${this.configuracao.idlocalconfig}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.items = []
          this.reset()
        })
        .catch(this.setErrorSystem)
    }
  }
}
</script>